import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class OfferHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    updateDiscountPeriod(discountPeriod: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/offer/updateDiscountPeriod`, discountPeriod);
    }

    getDiscountPeriod(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/offer/getDiscountPeriod`);
    }

    addVoucherCode(discountValue: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/offer/addVoucherCode`, {}, { params: { discountValue: discountValue } });
    }

    getVoucherCode(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/offer/getVoucherCode`);
    }

    deleteVouchercode(discountCodeId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/offer/deleteVouchercode`, { params: { discountCodeId: discountCodeId } });
    }
}
